const Intro = () => {
  return (
    <section className=" pt-4 flex flex-col justify-center items-center gap-4 my-12 ">
      <h1 className=" text-4xl text-center text-base-100 font-medium md:text-6xl">
        Design solutions made easy
      </h1>
      <p className=" px-6 text-center text-md font-light text-neutral-content leading-6 md:max-w-2xl md:text-lg lg:text-xl">
        With over ten years of experience in various design disciplines, I’m
        your one-stop shop for your design needs.
      </p>
    </section>
  );
};
export default Intro;
